import { gql } from "@apollo/client";

export const SUBMIT_DEMOGRAPHIC_RESPONSES = gql`
  mutation SubmitDemographicResponses($sessionId: String!, $responses: [DemographicResponseInput!]!) {
    submitDemographicResponses(sessionId: $sessionId, responses: $responses) {
      id
      questionId
      textValue
      numberValue
      selectedOptionIds
    }
  }
`;
